<template>
  <div class="summary-item">
    <div class="col-12 col-md-4">
      <div
        class="summary-item__img"
        :style="{
          background: `linear-gradient(135deg, ${event} 0%,${primary} 50%,${secondary} 100%)`
        }"
      >
        <img
          v-if="order.Product.image"
          :src="order.Product.image"
          :alt="order.Product.name"
        />
      </div>
    </div>
    <div class="col-12 col-md-5">
      <div class="summary-item__content">
        <div class="-title">{{ order.Product.name }}</div>
        <p class="-bold">{{ order.Product.Location.name }}</p>
        <p>{{ order.Product.Location.address }}</p>

        <ul class="-package">
          <li>Package: {{ order.Term.name }}</li>
          <li>Start Date: {{ formatDate(order.OrderPackage.startAt) }}</li>
          <li>End Date: {{ formatDate(order.OrderPackage.endAt) }}</li>
          <li>Quantity: {{ order.OrderPackage.quantity }}</li>
        </ul>
      </div>
    </div>
    <div class="col-12 col-md-3">
      <div class="summary-item__content text-right">
        <p class="-bold -custom">{{ cost | currency }}</p>
        <div class="d-flex justify-content-end">
          <ActionButton
            class="w-auto p-10 m-0 mr-10"
            mode="outline"
            type="button"
            label="<i class='fa fa-edit'></i>"
            :theme="{ primary, secondary, event, danger }"
            @customEvent="onEditSchedule"
          />
          <button
            class="btn btn-outline-danger p-10 w-auto"
            type="button"
            @click="onRemoveSchedule"
          >
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "@/helpers/moment";
import ActionButton from "@/components/ActionButton";
export default {
  components: {
    ActionButton
  },
  props: {
    order: {
      type: Object,
      default: () => null
    },
    index: {
      type: [Number, String],
      default: null
    }
  },
  filters: {
    currency(val) {
      return "P " + val;
    }
  },
  computed: {
    cost() {
      return (
        this.order.OrderPackage.total * this.order.OrderPackage.quantity
      ).toLocaleString("en-US", {
        minimumFractionDigits: 2
      });
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  methods: {
    ...mapActions({
      ORDER_REMOVE_SCHEDULE: "ORDER_REMOVE_SCHEDULE"
    }),
    formatDate(date) {
      return moment(date).format("MMMM DD, YYYY h:mm A");
    },
    onEditSchedule() {
      const editSchedule = {
        index: this.index,
        data: {
          ...this.order,
          ...{
            progress: "productDetails"
          }
        }
      };
      this.$emit("onEditSchedule", editSchedule);
    },
    onRemoveSchedule() {
      this.$swal({
        title: "Are you sure you want to delete this order?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          this.ORDER_REMOVE_SCHEDULE({ index: this.index });
          this.$toastr.success("Order is removed", "Success");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.summary {
  &-item {
    display: flex;
    flex-wrap: wrap;
    margin: 0 0.9375rem 1.875rem 0;

    @media (min-width: $screen-lg) {
      margin: 0 0 1.875rem 0;
    }

    @media (min-width: $screen-md) {
      margin-left: -0.9375rem;
      margin-right: 0;
    }

    .negate {
      padding-right: 0;

      @media (max-width: $screen-sm) {
        padding-right: 15px;
      }
    }

    &__img {
      border-radius: 6px;
      height: 160px;
      overflow: hidden;
      width: 100%;
      > img {
        height: inherit;
        object-fit: cover;
        width: 100%;
      }
    }
    @media (min-width: 800px) {
      &__img {
        width: 80%;
      }
    }
    &__content {
      p {
        font-size: 16px;
        line-height: 24px;
        margin: 0;
      }
      .-bold {
        font-weight: 500;
      }
      .-custom {
        margin-top: 28px;
        margin-bottom: 10px;
      }
      .-title {
        font-size: 18px;
        font-weight: 500;
        line-height: 28px;
      }

      ul.-package {
        list-style: none;
        margin-top: 20px;
        padding: 0;
      }
    }
    &__actions {
      text-align: right;
    }
    &__highlight {
      background: #e6f3f4;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      padding: 15px 20px;
      text-align: right;
    }
  }
  @media (max-width: 767px) {
    &-item {
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      flex-flow: column wrap;
      height: 100%;
      > div {
        padding: 0 !important;
      }
      &__img {
        height: 220px;
        overflow: hidden;
        width: 100%;
      }
      &__content {
        padding: 20px 0;
        .-title {
          margin-bottom: 28px;
        }
        .-custom {
          margin-top: -20px;
        }
      }
    }
  }
}

.btn {
  width: 100%;

  @media (min-width: $screen-md) {
    width: auto;
  }
}
</style>
